import { render, staticRenderFns } from "./RewardsHistory.vue?vue&type=template&id=4ea74568&scoped=true&"
import script from "./RewardsHistory.vue?vue&type=script&lang=js&"
export * from "./RewardsHistory.vue?vue&type=script&lang=js&"
import style0 from "./RewardsHistory.vue?vue&type=style&index=0&id=4ea74568&scoped=true&lang=scss&"
import style1 from "./RewardsHistory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea74568",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
